import { isEmpty as isEmptyLodash } from 'lodash';
import { PANEL_FILTERS } from 'utils/constants/Filters';
import { TFilter } from 'utils/context/FilterContext/types';
import DK from 'utils/dictionaries/filter_dictionary';

export function getKeyByValue(
  dictionary: { [key: string]: string },
  value: string,
) {
  return Object.keys(dictionary).find((key) => dictionary[key] === value) || '';
}

export function isEmpty(value: unknown) {
  if (Array.isArray(value)) {
    return isEmptyLodash(value.filter((exists) => exists));
  }
  return isEmptyLodash(value);
}

export const getFilterCount = (filters: TFilter) => {
  const singleCount = [
    DK.CURRENT_STATE,
    DK.ID_TYPE,
    DK.MODE_OF_SHIPMENT,
    DK.CONNECTIVITY,
  ].filter((key) => key in filters).length;

  const multiCount = [
    DK.LOCATIONS,
    DK.PROPERTIES,
    DK.EVENTS_AND_DATES,
    DK.RELATED_ENTITY_ID,
  ].reduce((sum, key) => sum + (filters[key] || []).length, 0);

  return singleCount + multiCount;
};

export const hasFilters = (filters: TFilter, matchFilters = PANEL_FILTERS) => {
  return matchFilters.some((filterKey) => filterKey in filters);
};

const overrides: { [key: string]: string } = {
  LOCATION_NAME_DESTINATION: 'DESTINATION_LOCATION_NAME',
  LOCATION_NAME_ORIGIN: 'ORIGIN_LOCATION_NAME',
  LOCATION_NAME_ANY_STOP: 'STOP_LOCATION_NAME',
  LOCATION_NAME_EVERY_STOP: 'STOP_LOCATION_NAME',
  LOCATION_NAME_CURRENT: 'STOP_LOCATION_NAME',

  LOCATION_ADDRESS_DESTINATION: 'DESTINATION_ADDRESS',
  LOCATION_ADDRESS_ORIGIN: 'ORIGIN_ADDRESS',
  LOCATION_ADDRESS_ANY_STOP: 'STOP_ADDRESS',
  LOCATION_ADDRESS_EVERY_STOP: 'STOP_ADDRESS',
  LOCATION_ADDRESS_CURRENT: 'STOP_ADDRESS',

  LOCATION_AIRPORT_CODE_DESTINATION: 'DESTINATION_AIRPORT_CODE',
  LOCATION_AIRPORT_CODE_ORIGIN: 'ORIGIN_AIRPORT_CODE',
  LOCATION_AIRPORT_CODE_ANY_STOP: 'STOP_AIRPORT_CODE',
  LOCATION_AIRPORT_CODE_EVERY_STOP: 'STOP_AIRPORT_CODE',
  LOCATION_AIRPORT_CODE_CURRENT: 'STOP_AIRPORT_CODE',

  LOCATION_CITY_DESTINATION: 'DESTINATION_CITY',
  LOCATION_CITY_ORIGIN: 'ORIGIN_CITY',
  LOCATION_CITY_ANY_STOP: 'STOP_CITY',
  LOCATION_CITY_EVERY_STOP: 'STOP_CITY',
  LOCATION_CITY_CURRENT: 'STOP_CITY',

  LOCATION_COUNTRY_DESTINATION: 'DESTINATION_COUNTRY',
  LOCATION_COUNTRY_ORIGIN: 'ORIGIN_COUNTRY',
  LOCATION_COUNTRY_ANY_STOP: 'STOP_COUNTRY',
  LOCATION_COUNTRY_EVERY_STOP: 'STOP_COUNTRY',
  LOCATION_COUNTRY_CURRENT: 'STOP_COUNTRY',

  LOCATION_PORT_CODE_DESTINATION: 'DESTINATION_PORT_CODE',
  LOCATION_PORT_CODE_ORIGIN: 'ORIGIN_PORT_CODE',
  LOCATION_PORT_CODE_ANY_STOP: 'STOP_PORT_CODE',
  LOCATION_PORT_CODE_EVERY_STOP: 'STOP_PORT_CODE',
  LOCATION_PORT_CODE_CURRENT: 'STOP_PORT_CODE',

  LOCATION_STATE_DESTINATION: 'DESTINATION_STATE',
  LOCATION_STATE_ORIGIN: 'ORIGIN_STATE',
  LOCATION_STATE_ANY_STOP: 'STOP_STATE',
  LOCATION_STATE_EVERY_STOP: 'STOP_STATE',
  LOCATION_STATE_CURRENT: 'STOP_STATE',

  LOCATION_ZIP_DESTINATION: 'DESTINATION_ZIP',
  LOCATION_ZIP_ORIGIN: 'ORIGIN_ZIP',
  LOCATION_ZIP_ANY_STOP: 'STOP_ZIP',
  LOCATION_ZIP_EVERY_STOP: 'STOP_ZIP',
  LOCATION_ZIP_CURRENT: 'STOP_ZIP',
};

export const overrideMap = (property: string, scopes: string[] | undefined) => {
  const overrideKey = property + '_' + scopes?.[0];
  if (Object.keys(overrides).includes(overrideKey)) {
    return overrides[overrideKey];
  }
  return property;
};
